import { FC } from 'react';

import cs from 'classnames';

import { ReactComponent as TickCircle } from 'assets/icons/tickCircle.svg';

import styles from './ThankYouMessage.module.scss';

interface ThankYouMessageProps {
  isShowThankYouMessage: boolean;
}
const ThankYouMessage: FC<ThankYouMessageProps> = ({
  isShowThankYouMessage
}) => {
  return (
    <div
      className={cs(styles.successMessage, {
        [styles.visible]: isShowThankYouMessage
      })}
    >
      <div className={styles.iconContainer}>
        <TickCircle />
      </div>
      <div className={styles.textContainer}>
        <h5>Thank you!</h5>
        <p>
          Your message has been sent successfully. We appreciate your trust in
          Joblio for your recruitment needs.
        </p>
      </div>
    </div>
  );
};

export default ThankYouMessage;
